import { ZoneAction, ZoneState } from 'store/data/zone';
import { domainUtility } from 'utility';

const initialState: ZoneState = { allIds: [], byId: {} };

const zoneReducer = (
  state: ZoneState = initialState,
  action: ZoneAction,
): ZoneState => {
  switch (action.type) {
    case 'data/zone/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/zone/SET':
      return domainUtility.set(state, action.payload);
    case 'data/zone/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/zone/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/zone/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default zoneReducer;
